import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';
import type { HomeServiceOrderProvider, HomeServiceOrderProviderInput } from '@/models/homeService';

// Fragments
import './fragments/homeServiceOrderProviderFragment';

export const assignProviderToHomeServiceOrder = async (data: HomeServiceOrderProviderInput) => {
  const response = await mutationExecute({
    variables: {
      data,
    },
    mutation: graphql(`
      mutation AssignProviderToHomeServiceOrder($data: HomeServiceOrderProviderInputType!) {
        assignProviderToHomeServiceOrder(data: $data) {
          ...HomeServiceOrderProviderFragment
        }
      }
    `),
  });

  return response.data?.assignProviderToHomeServiceOrder as HomeServiceOrderProvider;
};
